<template lang="pug">
.tab-nav2
  template(v-if="menu3 == 'parlay'")
    ul
      li.live
        a(href='javascript:void(0);' @click="parlaySelect('live')" :class="{ 'active': menu3 == 'parlay' && menu1 === 'live' }")
          img(src='images/icon/others/live-red.svg')
          | {{ $t("ui.live") }}
      li
        a(href='javascript:void(0);' @click="parlaySelect('early')" :class="{ 'active': menu3 == 'parlay' && menu1 === 'early' }")
          i.fa-solid.fa-calendar
          |  {{ $t("ui.early") }}
      li
        a(href='javascript:void(0);' @click="parlaySelect('today')" :class="{ 'active': menu3 == 'parlay' && ['today','upcoming'].includes(menu1) }")
          i.fa-solid.fa-clock
          |  {{ $t("ui.today") }}
  template(v-else)
    ul
      li.live
        a(href='javascript:void(0);' @click="showSelected('live')" :class="{ 'active': menu1 === 'live' }")
          img(src='images/icon/others/live-red.svg')
          | {{ $t("ui.live") }}   
          span.event-count(v-if="!isWorldCupEvent") {{ liveCount }}
      li
        a(href='javascript:void(0);' @click="showSelected('early')" :class="{ 'active': menu1 === 'early' }")
          i.fa-solid.fa-calendar
          |  {{ $t("ui.early") }}  
          span.event-count(v-if="!isWorldCupEvent") {{ earlyCount }}
      li
        a(href='javascript:void(0);' @click="showSelected('today')" :class="{ 'active': ['today','upcoming'].includes(menu1) && menu3 != 'orz' }")
          i.fa-solid.fa-clock
          |  {{ $t("ui.today") }}  
          span.event-count(v-if="!isWorldCupEvent") {{ todayCount }}
      li
        a(href='javascript:void(0);' @click="showSelected('orz')" :class="{ 'active': menu3 === 'orz' }")
          i.fa-solid.fa-calendar-days
          |  {{ $t("ui.outright") }}  
          span.event-count(v-if="!isWorldCupEvent") {{ outrightCount }}
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";

export default {
  props: {
    mode: {
      type: Number
    },
    order: {
      type: Array,
      default: () => []
    },
    items: {
      type: Object,
      default: () => {}
    },
    live: {
      type: Object,
      default: () => {}
    },
    today: {
      type: Object,
      default: () => {}
    },
    early: {
      type: Object,
      default: () => []
    },
    sports: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      options: {}
    };
  },
  computed: {
    selectedSportType() {
      return this.menu2;
    },
    selectedSportName() {
      return this.sports[this.menu2];
    },
    selectedCount() {
      if (this.items != null && this.items[this.menu2] != null && this.items[this.menu2].hasOwnProperty("tn")) {
        return this.items[this.menu2].tn;
      } else {
        return 0;
      }
    },
    lang() {
      return this.$store.getters.language;
    },
    menu0() {
      return this.$store.getters.menu0;
    },
    menuY() {
      return this.$store.state.layout.menuY;
    },
    isWorldCupEvent() {
      return this.menu0 === "event" && String(this.menuY) === "3";
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    isOutrightEmpty() {
      return this.today[this.menu2] != null && this.today[this.menu2].hasOwnProperty("orz") && this.today[this.menu2].orz <= 0;
    },
    liveCount() {
      if (this.menu2 && this.live[this.menu2] && this.live[this.menu2].tn > 0) {
        return this.live[this.menu2].tn;
      }
      return 0;
    },
    todayCount() {
      if (this.menu2 && this.today[this.menu2] && this.today[this.menu2].tn > 0) {
        return this.today[this.menu2].tn;
      }
      return 0;
    },
    earlyCount() {
      if (this.menu2 && this.early[this.menu2] && this.early[this.menu2].tn > 0) {
        return this.early[this.menu2].tn;
      }
      return 0;
    },
    outrightCount() {
      if (this.menu2 && this.today[this.menu2] && this.today[this.menu2].hasOwnProperty("orz") && this.today[this.menu2].orz > 0) {
        return this.today[this.menu2].orz;
      }
      return 0;
    }
  },
  watch: {
    menu2() {
      this.$nextTick(() => {
        this.scrollToActive();
      });
    }
  },
  mounted() {
    this.initial();
    this.$nextTick(() => {
      this.scrollToActive();
    });
  },
  methods: {
    totalCount(e) {
      let count = 0;
      if (this.live[e] && this.live[e].tn > 0) {
        count += this.live[e].tn;
      }
      if (this.today[e] && this.today[e].tn > 0) {
        count += this.today[e].tn;
      }
      if (this.early[e] && this.early[e].tn > 0) {
        count += this.early[e].tn;
      }
      return count;
    },
    getSportsImage(e) {
      return e == 0 ? "all.svg?v=12" : config.getSportsImage(e);
    },
    initial() {
      var sportsList = Object.keys(this.items);
      if (!sportsList.includes(this.menu2.toString())) {
        if (sportsList.length > 0) {
          var x = sportsList[0];
          if(this.mode) {
            this.showSelected(x);
          }
        }
      }
    },
    scrollToActive() {
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        const scrollingWrapper = this.$el.querySelector('.scrolling-wrapper');
        if (!scrollingWrapper) return;
        
        const activeCategory = scrollingWrapper.querySelector('.category.active');
        if (!activeCategory) return;
        
        const wrapperRect = scrollingWrapper.getBoundingClientRect();
        const activeRect = activeCategory.getBoundingClientRect();
        
        // Check if active item is already visible
        const isVisible = activeRect.left >= wrapperRect.left && 
                         activeRect.right <= wrapperRect.right;
        
        if (isVisible) return;
        
        // Calculate scroll position to center the active item
        const scrollLeft = scrollingWrapper.scrollLeft;
        const activeLeft = activeRect.left - wrapperRect.left + scrollLeft;
        const activeWidth = activeRect.width;
        const wrapperWidth = wrapperRect.width;
        
        // Center the active item in the viewport
        const targetScroll = activeLeft - (wrapperWidth / 2) + (activeWidth / 2);
        
        // Use scrollTo with smooth behavior, fallback to scrollLeft for older browsers
        if (scrollingWrapper.scrollTo) {
          scrollingWrapper.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
          });
        } else {
          scrollingWrapper.scrollLeft = targetScroll;
        }
      });
    },
    showSelected(e) {
      this.$emit("setMenu1", e);
    },
    parlaySelect(e) {
      this.$emit("setMenu3", "parlay", e);
    }
  }
};
</script>
